// client/src/components/ai/GerarTextoIABox.js
// Caixa reutilizável de geração de TEXTO por IA (Venice.ai) — usada em
// Templates (Contrato/Anamnese/Mensagem/Certificado), Páginas
// institucionais, Conteúdos da Home, FAQ e Políticas. Cada tela passa seu
// próprio `endpoint` (já resolve o prompt certo no server) e decide o que
// fazer com o resultado via `onGenerated`. Mesmo padrão visual já usado em
// CertificadoCanvasEditor.js.
import React, { useState } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { useGerarTextoIA } from '../../hooks/useAIGeracao';
import useAlert from '../../hooks/useAlert';
import { useGeracaoIAGate, GeracaoIAUpsellBanner } from './useGeracaoIAGate';

const GerarTextoIABox = ({
    endpoint,
    extraPayload = {},
    onGenerated,
    placeholder = 'Descreva o que você quer gerar...',
    disabled = false,
    disabledHint = null,
    successMessage = 'Conteúdo gerado! Revise antes de salvar.',
    buttonLabel = 'Gerar com IA',
}) => {
    const [descricao, setDescricao] = useState('');
    const { setAlert } = useAlert();
    const gerarComIA = useGerarTextoIA(endpoint);
    const { podeGerarComIA, planPermiteIA } = useGeracaoIAGate();

    const handleGerar = () => {
        if (!descricao.trim() || disabled) return;
        gerarComIA.mutate(
            { descricao, ...extraPayload },
            {
                onSuccess: (data) => {
                    onGenerated(data);
                    setAlert(successMessage, 'success');
                },
            }
        );
    };

    if (!podeGerarComIA) {
        return <GeracaoIAUpsellBanner planPermiteIA={planPermiteIA} />;
    }

    return (
        <div className="ai-gerar-box flex gap-2 items-start mb-4 p-3 bg-purple-50 rounded border border-purple-200">
            <Sparkles size={20} className="text-purple-600 mt-2 icon" />
            <div className="flex-1">
                <textarea
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    className="form-input"
                    rows={2}
                    placeholder={placeholder}
                    disabled={disabled}
                />
                {disabled && disabledHint && <p className="form-hint text-amber-600 mt-1">{disabledHint}</p>}
            </div>
            <button
                type="button"
                onClick={handleGerar}
                disabled={disabled || !descricao.trim() || gerarComIA.isPending}
                className="action-button action-button-primary"
                style={{ whiteSpace: 'nowrap' }}
            >
                {gerarComIA.isPending ? <Loader2 size={16} className="animate-spin icon" /> : <Sparkles size={16} className="icon" />}
                {buttonLabel}
            </button>
        </div>
    );
};

export default GerarTextoIABox;
